import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import IMG01 from "../../images/services/tc/Cloud-strategy.webp";
import IMG02 from "../../images/services/tc/Digital-transformation.webp";
import IMG03 from "../../images/services/tc/Mergers-&-acquisitions.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="solutions">
                                <h2>Our Forte</h2>
                            </div>
                            <p>Giving your business a digital makeover</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>1.3T
                                        <span>Spent</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>No.1
                                        <span>Priority for businesses</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Cloud strategy</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Digital transformation</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Mergers & acquisitions</div>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Cloud strategy</h2>
                                <p>In this era, missing out on cloud strategy might be critical. To better equip with the challenges that the future poses for businesses, cloud dependence is a prerequisite, and cloud excellence is what we must aim for. TekRevol delivers on its promise of making the world a digital-sustainable society by providing modern businesses with a comprehensive cloud strategy that enables them for the future.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG01}
                                    effect="blur" alt="Migration" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Digital transformation</h2>
                                <p>Digital transformation is vital when we talk about when strategic and technological advancement. TekRevol is a technology consultant allowing enterprises to revisit and configure their process according to the new normal and improve their current status. To ensure maximum, our experts provide extensive assistance to all our clients.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image">
                                <LazyLoadImage
                                    src={IMG02}
                                    effect="blur" alt="Development" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Mergers & acquisitions</h2>
                                <p>Mergers and acquisitions have always been a hassle in the tech industry. Our experts take care of all the requirements and prerequisites to ensure a smooth process. TekRevol’s consultancy solutions are the perfect fit for all your needs to assist modern technology businesses in carrying out business operations seamlessly.
                                </p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG03}
                                    effect="blur" alt="Deployment" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Technologysec;